import PropTypes from 'prop-types'
import Button from '../../ui/elements/button'

export default function OverlaySidebar({
  children,
  onDismiss,
  canDismiss,
  backButtonTitle,
  title,
  sidebarOverlay,
}) {
  return (
    <div className="tw-relative tw-flex-shrink-0 tw-flex tw-flex-col tw-h-full tw-w-toolbar-overlay tw-border-r tw-border-0 tw-border-solid tw-max-w-sm tw-border-system-grey-200">
      {sidebarOverlay ? (
        <div className="tw-absolute tw-bg-white tw-bg-opacity-95 tw-w-full tw-h-full tw-z-50">
          {sidebarOverlay}
        </div>
      ) : null}
      <section className="tw-custom-section tw-p-5">
        <div className="tw-flex tw-items-center tw-justify-between">
          <Button
            icon="chevron-left"
            onClick={onDismiss}
            disabled={!canDismiss}>
            {backButtonTitle}
          </Button>
          {title ? (
            typeof title === 'string' ? (
              <h2 className="tw-custom-reset-heading tw-text-lg tw-font-medium">
                {title}
              </h2>
            ) : (
              title
            )
          ) : null}
        </div>
      </section>
      <div className="tw-h-full tw-overflow-y-auto">{children}</div>
    </div>
  )
}

OverlaySidebar.propTypes = {
  backButtonTitle: PropTypes.string,
  canDismiss: PropTypes.bool,
  children: PropTypes.node,
  onDismiss: PropTypes.func,
  title: PropTypes.node,
  sidebarOverlay: PropTypes.node,
}
